export enum MppButtonType {
  FILL = 'fill',
  STROKE = 'stroke',
}
